import './Button.scss'

const Button = ({text, size, style, icon1, icon2, color, onClick, disabled}) => {
    // Size = xs, s, m, l
    // Style = rounded, sharp
    // Color = orange, gray, transparent, blue, monogray, green

  // Inline styles for Elementor override protection
  // border-radius based on style prop (sharp=0, rounded=6px, morerounded=20px)
  const getBorderRadius = () => {
    if (style === 'sharp') return '0px';
    if (style === 'morerounded') return '20px';
    if (style === 'rounded') return '6px';
    return '6px'; // default
  };

  const buttonInlineStyle = {
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    boxSizing: 'border-box',
    cursor: disabled ? 'not-allowed' : 'pointer',
    pointerEvents: 'auto',
    borderRadius: getBorderRadius(), // INLINE OVERRIDE - höchste Priorität!
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={icon1 || icon2 ? `${size} ${style} ${color} btn-icon` : `${size} ${style} ${color} btn`}
      style={buttonInlineStyle}
    >
      {icon1 && <span className='icon'>{icon1}</span>} {text} {icon2 && <span className='icon'>{icon2}</span>}
    </button>
  )
}

export default Button